export default __webpack_public_path__ + "static/media/dePin.f16706e0.svg";